


























































import Vue from "vue";
import Filters from "../components/auction/Filters.vue";
import Item from "../components/Item.vue";
import LoginForm from "../components/user/LoginForm.vue";
import PostView from "./PostView.vue";
import { itemApi } from "../utils/axios";
import { AxiosResponse } from "axios";

export default Vue.extend({
  name: "Auction",

  components: {
    Filters,
    PostView,
    Item,
    LoginForm
  },
  data: () => ({
    page: 1,
    totalPage: 1,
    filters: {
      status: false,
      category: [],
      grade: [],
      si: null,
      gu: null
    },
    dialog: false,
    pleaseLogin: false,
    message: "이 필요한 서비스입니다.🐯",
    items:[],
  }),
  computed: {
    login (): string {
      return this.$store.state.userModule.status.loggedIn;
    },
  },
  methods: {
    getPage(page: number) {
      this.$store.dispatch("auctionModule/setPage", page);
      this.getItems();
    },
    getItems(){ // page번호와 filter 데이터가 바뀔때마다 item을 요청합니다.
      // store에 저장된 page와 필터데이터로 아이템을 조회합니다.
      const page = this.$store.state.auctionModule.page;
      const filters = this.$store.state.auctionModule.filters;
      
      itemApi.getItemPage(page, filters).then((res: AxiosResponse) => {
        this.totalPage = res.data.total_pages;
        this.items = res.data.object;
        // console.log(this.items)
      })
    },
    // reset버튼을 누르면 기본 필터값으로 적용됩니다.
    reset(data: string) {
      const tmpFilter = {status: false, category: [], grade: [], si: null, gu: null, name: data}
      this.$store.dispatch("auctionModule/setFilter", tmpFilter);
      this.filters = tmpFilter;
    },
  },
  mounted() {
    const data = this.$store.state.auctionModule.filters.name;
    this.reset(data);
    this.getItems();
    this.filters = this.$store.state.auctionModule.filters;
    this.page = this.$store.state.auctionModule.page;
  }
});
